import { render } from "./FicheContribuable.vue?vue&type=template&id=4eaad6c4"
import script from "./FicheContribuable.vue?vue&type=script&lang=js"
export * from "./FicheContribuable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__